import React, { useRef, useEffect } from "react";

// crop: optional { x, y, width, height } source rect on imageObj. Box and
// polygon coordinates are relative to the crop (or the full image when omitted).
const CanvasImage = ({ imageObj, maxWidth = 500, maxHeight = 500, coordinates = [], crop }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !imageObj) return;

    const ctx = canvas.getContext("2d");

    const src = crop || { x: 0, y: 0, width: imageObj.width, height: imageObj.height };
    const scale = Math.min(maxWidth / src.width, maxHeight / src.height);
    const scaledWidth = src.width * scale;
    const scaledHeight = src.height * scale;

    canvas.width = scaledWidth;
    canvas.height = scaledHeight;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(imageObj, src.x, src.y, src.width, src.height, 0, 0, scaledWidth, scaledHeight);

    coordinates.forEach(({ coords = [], polygons = [], color }) => {
      ctx.strokeStyle = color;
      ctx.lineWidth = 2;
      coords.forEach(([x1, y1, x2, y2]) => {
        const rectX = x1 * scale;
        const rectY = y1 * scale;
        const rectWidth = (x2 - x1) * scale;
        const rectHeight = (y2 - y1) * scale;
        ctx.strokeRect(rectX, rectY, rectWidth, rectHeight);
      });
      // Soft tissue lesions are irregular areas; fill them so they read at a glance.
      polygons.forEach((points) => {
        ctx.beginPath();
        points.forEach(([x, y], i) => {
          if (i === 0) ctx.moveTo(x * scale, y * scale);
          else ctx.lineTo(x * scale, y * scale);
        });
        ctx.closePath();
        ctx.save();
        ctx.globalAlpha = 0.35;
        ctx.fillStyle = color;
        ctx.fill();
        ctx.restore();
        ctx.stroke();
      });
    });
  }, [imageObj, maxWidth, maxHeight, coordinates, crop]);

  return <canvas ref={canvasRef} style={{ maxWidth: "100%", height: "auto", borderRadius: 8 }} />;
};

export default CanvasImage;
